// extracted by mini-css-extract-plugin
export var content = "layout-module--content--K-wVB";
export var footer = "layout-module--footer--rX0Dt";
export var footerWrapper = "layout-module--footerWrapper--xZoAz";
export var companyAddress = "layout-module--companyAddress--2cugI";
export var siteInfo = "layout-module--siteInfo--MNT63";